import { UTCDate } from '@date-fns/utc';
import * as Sentry from '@sentry/react';
import { TransactionView } from '../../types/entity-types';

export const checkDuplicateTransactions = (transactions?: TransactionView[]) => {
  if (!transactions || !transactions.length) {
    return;
  }

  const transactionsLength = transactions.length;

  // We use the fspDate as a proxy to check for duplicate transactions
  // There should not be two transactions with the same fspDate, amount and isCredit
  // If there are, it is potentially a duplicate transaction
  // If the transaction has not settled, other fspRecord properties are null. They are not reliable to check for duplicates.
  const uniqueTransactionsByFspDate = new Set(
    transactions.map((t) => `${new UTCDate(t.fspDate).toISOString()}-${t.amount}-${t.isCredit}`),
  );

  if (transactionsLength !== uniqueTransactionsByFspDate.size) {
    // We alert Sentry but we don't want to crash the app
    Sentry.captureException('Potential duplicate transactions found', {
      extra: {
        transactionsLength,
        uniqueTransactionsByFspDateLength: uniqueTransactionsByFspDate.size,
      },
    });
  }
};
